/* HomePlunge Canada notice.

   Canada is a fully working market: CAD presentment pricing, provincial tax
   calculated at checkout, and the FreeShipping automatic discount covers CA
   alongside US. Nothing about the buying flow needs changing. The problem was
   that every shipping line on the site said "Free U.S. shipping", so Canadians
   reasonably concluded we do not ship to them and emailed to ask. This script
   says yes, in the places where they were reading no.

   It is the inverse of hp-au-gate.js. That one removes a purchase path. This
   one confirms it.

   Detection mirrors the AU gate: window.HP_CA is set server-side from
   localization.country.iso_code, Shopify.country is the fallback, and
   ?hp_ca=1 forces the state for testing from outside Canada (?hp_ca=0 clears). */
(function () {
  'use strict';

  var TEST_KEY = 'hp-ca-test';
  var BAR_KEY = 'hp-ca-bar-dismissed';
  var FAQ = '/pages/faqs';

  function testFlag() {
    try {
      var q = new URLSearchParams(window.location.search);
      if (q.get('hp_ca') === '1') { sessionStorage.setItem(TEST_KEY, '1'); return true; }
      if (q.get('hp_ca') === '0') { sessionStorage.removeItem(TEST_KEY); return false; }
      return sessionStorage.getItem(TEST_KEY) === '1';
    } catch (e) { return false; }
  }

  function isCA() {
    if (window.HP_CA === true) return true;
    try { if (window.Shopify && window.Shopify.country === 'CA') return true; } catch (e) {}
    return testFlag();
  }

  if (!isCA()) return;
  document.documentElement.classList.add('hp-ca');

  /* Rewrite the US-only shipping wording. Exact strings only, and only inside
     text nodes, so no markup or attribute is touched. Runs again on mutation
     because the sticky bar and cart drawer mount late. */
  var SWAPS = [
    ['Free U.S. shipping included.', 'Free shipping to Canada included.'],
    ['Free U.S. shipping.', 'Free shipping to Canada.'],
    ['Free U.S. Shipping', 'Free Shipping to Canada'],
    ['Free U.S. shipping', 'Free shipping to Canada'],
    ['A $299 value, included on every order.', 'Included on every chiller order.'],
    ['+ est. tax, calculated at checkout', '+ GST/HST, calculated at checkout']
  ];

  var MARKERS = ['Free U.S', '$299 value', 'est. tax, calculated at checkout'];

  function swapText() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var v = n.nodeValue;
        if (!v) return NodeFilter.FILTER_REJECT;
        var hit = false;
        for (var i = 0; i < MARKERS.length; i++) {
          if (v.indexOf(MARKERS[i]) !== -1) { hit = true; break; }
        }
        if (!hit) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, hits = [];
    while ((n = walker.nextNode())) hits.push(n);
    hits.forEach(function (node) {
      var v = node.nodeValue;
      for (var i = 0; i < SWAPS.length; i++) {
        if (v.indexOf(SWAPS[i][0]) !== -1) v = v.split(SWAPS[i][0]).join(SWAPS[i][1]);
      }
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  }

  function wireBar() {
    var bar = document.querySelector('.hpcabar');
    if (!bar) return;
    var dismissed = false;
    try { dismissed = localStorage.getItem(BAR_KEY) === '1'; } catch (e) {}
    if (dismissed) { bar.hidden = true; return; }
    bar.hidden = false;
    var x = bar.querySelector('.hpaubar__x');
    if (x && !x.dataset.wired) {
      x.dataset.wired = '1';
      x.addEventListener('click', function () {
        bar.hidden = true;
        try { localStorage.setItem(BAR_KEY, '1'); } catch (e) {}
      });
    }
  }

  function run() { swapText(); wireBar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  window.addEventListener('load', run);
})();
